module.exports = __webpack_public_path__ + "static/media/foto1.f4bd103f.png";